export default "__VITE_ASSET__VvRH3c2X8gYoCaXG8sx66A__"